import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { LANGUAGE_KEYS } from 'config/languageKeys.ts';

import { selectLayoutConfig } from 'store/config/selectors.ts';

import { RetryController } from 'services/opf-retry-mechanism';

import isFunction from 'utils/function.ts';
import { isWeb } from 'utils/responsiveness.ts';

import Dialog from 'components/Dialog';
import { textColorStyles } from 'components/Text/styles.ts';

import styles from './styles.ts';

const {
    VITAL_REQUEST_FAILED_RETRY_TITLE,
    VITAL_REQUEST_FAILED_RETRY_DESCRIPTION,
} = LANGUAGE_KEYS;

function VitalErrorDialog() {
    const [isDialogVisible, setIsDialogVisible] = useState(false);

    useEffect(() => {
        const unsubscribe = RetryController.subscribe((visible) => {
            setIsDialogVisible(visible);
        });

        return () => {
            unsubscribe();
        };
    }, []);

    const actionButtonOnPress = useCallback(() => {
        RetryController.onVitalDialogActionButtonPress();
    }, []);

    const { t } = useTranslation();

    const { primary } = useSelector(selectLayoutConfig);

    const handleOnRequestClose = useCallback(() => {
        if (isFunction(RetryController.vitalDialogOnBackPress)) {
            RetryController.vitalDialogOnBackPress();
        }
    }, []);

    useEffect(() => {
        if (
            isWeb &&
            isFunction(RetryController.vitalDialogOnBackPress) &&
            isDialogVisible
        ) {
            window.history.pushState({}, '', null);
            window.addEventListener('popstate', handleOnRequestClose);
        }

        return () => {
            if (isWeb) {
                window.removeEventListener('popstate', handleOnRequestClose);
            }
        };
    }, [isDialogVisible, handleOnRequestClose]);

    return (
        <Dialog
            visible={isDialogVisible}
            title={VITAL_REQUEST_FAILED_RETRY_TITLE}
            description={VITAL_REQUEST_FAILED_RETRY_DESCRIPTION}
            descriptionNumberOfLines={10}
            actionButtonTitle={t(RetryController.vitalDialogActionButtonTitle)}
            actionButtonAccessibilityLabel={t(
                RetryController.vitalDialogActionButtonTitle,
            )}
            actionButtonOnPress={actionButtonOnPress}
            actionButtonFillColor={primary}
            actionButtonTextStyle={textColorStyles.black}
            onRequestClose={handleOnRequestClose}
            style={styles.dialog}
        />
    );
}

export default VitalErrorDialog;
